import { Injectable } from '@angular/core';
import { PouchdbService } from '../../shared/pouchDb.service';
import { Constants } from '../../shared/models/constants'
import { BookData } from '../../shared/models/bookData';
import { ShelfValues } from '../../shared/models/shelfEnums';
import { Page } from '../../shared/models/page';
import { Book } from '../../shared/models/book';
import { Subject } from 'rxjs';
import { EditorService } from './editor.service'

@Injectable()
export class EditOptionService {
    localDB; remoteDB;
    pageContentData: Subject<any> = new Subject();
    pageContentData$ = this.pageContentData.asObservable();

    public bookTemplates: any;
    public bookTemplateObj: any;

    constructor(public pouchService: PouchdbService, public editorService: EditorService) {
        this.bookTemplates = Constants.getTemplates();
        this.localDB = pouchService.localDB;
        //
    }


    //Update operation - Saving enrichments to the pouchDb

    getPageContentData(data) {
        this.pageContentData.next(data);

    }


    savePageContent(docId, pageContent) {
        var self = this;
        this.pouchService.localDB.find({
            selector: { type: 'pageContent', _id: docId },
        }).then(function (result) {
            if (result.docs.length > 0) {

                result.docs[0].pageContent = pageContent;
                return self.pouchService.localDB.put(result.docs[0]).then(function (response) {
                    self.getPageContentData(result.docs[0]);
                }).catch(function (err) {
                    console.log(err);
                });
            }
        }).catch(function (err) {

        });
    }

    getPageContent(id) {
        var self = this;
        return new Promise((resolve, reject) => {
            self.pouchService.localDB.find({
                selector: { type: 'pageContent', _id: id },
            }).then(function (result) {
                if (result.docs.length > 0) {
                    resolve(result.docs[0]);
                }
            }).catch(function (err) {

            });
        });
    }
    async applyPageBgStyleToAllPages(pageContent, bookDataObj, parent) {
        var self = this;
        for (let i = 0; i < bookDataObj.pages.length; i++) {
            if ((i != 0 && i != bookDataObj.pages.length - 1) || (parent == 'ELE')) {
                var id = bookDataObj[bookDataObj.pages[i]].contentDocId;
                var pageObj = bookDataObj[bookDataObj.pages[i]];
                await this.getPageContent(id).then(function (res) {
                    if (res) {
                        if (pageObj.type == 'blankPage') {
                            res['pageContent'].pageBgStyle = pageContent.pageBgStyle;
                            bookDataObj[bookDataObj.pages[i]].isCustomBg = true;
                            self.updateBookDataObj(bookDataObj);
                            self.createPageContentDoc(res);
                        }
                    }
                });

            }
        }
    }
    async resetPageBgStyleToCurrentPage(pageObj, bookDataObj, bookObj, parent) {
        var self = this;
        let com = this.editorService.getIframeReference();
        if (parent == 'CreatedEBE') {
            var self = this;
            await this.getPageContent(pageObj.contentDocId).then(function (res) {
                if (res) {
                    self.bookTemplateObj = self.bookTemplates[bookObj.templateId + ""];
                    var pageBgStyle = { "type": "image", "url": self.bookTemplateObj.page_P, aspectRatio: true };
                    res['pageContent'].pageBgStyle = JSON.stringify(pageBgStyle);
                    self.createPageContentDoc(res);
                    let com = self.editorService.getIframeReference();
                    com.setPageBackGroundStyle(pageBgStyle);
                }
            });
        }
        else if (parent == 'ELE') {
            com.resetPageBg();
            var self = this;
            ////temperarly/////////
            // await this.getPageContent(pageObj.contentDocId).then(function (res) {
            //     if (res) {
            //         var pageBgStyle = "";
            //         res['pageContent'].pageBgStyle = JSON.stringify(pageBgStyle);
            //         self.createPageContentDoc(res);
            //     }
            // });
            ///////////////////
        }
        bookDataObj[pageObj.id + ''].isCustomBg = false;
        this.updateBookDataObj(bookDataObj);

    }
    async resetPageBgStyleToAllPages(bookDataObj, bookObj, parent) {
        var self = this;
        let com = this.editorService.getIframeReference();
        for (let i = 0; i < bookDataObj.pages.length; i++) {
            if ((i != 0 && i != bookDataObj.pages.length - 1) || (parent == 'ELE')) {
                var id = bookDataObj[bookDataObj.pages[i]].contentDocId;
                var pageObj = bookDataObj[bookDataObj.pages[i]];
                if (!pageObj.isCustomBg) {
                    com.resetPageBg();
                    /////temperarly/////////////////
                    await this.getPageContent(pageObj.contentDocId).then(function (res) {
                        if (res) {
                            var pageBgStyle = "";
                            res['pageContent'].pageBgStyle = JSON.stringify(pageBgStyle);
                            self.createPageContentDoc(res);
                        }
                    });
                    /////////////////
                }
                else if (pageObj.isCustomBg && pageObj.type == 'blankPage') {
                    //   await this.resetPageBgStyleToCurrentPage(pageObj, bookDataObj, bookObj, parent) 

                    let com = this.editorService.getIframeReference();
                    if (parent == 'CreatedEBE') {
                        var self = this;
                        await this.getPageContent(pageObj.contentDocId).then(function (res) {
                            if (res) {
                                self.bookTemplateObj = self.bookTemplates[bookObj.templateId + ""];
                                var pageBgStyle = { "type": "image", "url": self.bookTemplateObj.page_P, aspectRatio: true };
                                res['pageContent'].pageBgStyle = JSON.stringify(pageBgStyle);
                                self.createPageContentDoc(res);
                                let com = self.editorService.getIframeReference();
                                com.setPageBackGroundStyle(pageBgStyle);
                            }
                        });
                    }
                    else if (parent == 'ELE') {
                        com.resetPageBg();
                        var self = this;
                        ////temperarly/////////
                        await this.getPageContent(pageObj.contentDocId).then(function (res) {
                            if (res) {
                                var pageBgStyle = "";
                                res['pageContent'].pageBgStyle = JSON.stringify(pageBgStyle);
                                self.createPageContentDoc(res);
                            }
                        });
                        ///////////////////
                    }
                    bookDataObj[pageObj.id + ''].isCustomBg = false;
                    this.updateBookDataObj(bookDataObj);

                }

            }
        }
    }

    async applyPageNoToAllPages(pageContent, bookDataObj, parent) {
        var self = this;
        let com = this.editorService.getIframeReference();
        for (let i = 0; i < bookDataObj.pages.length; i++) {
            if ((i != 0 && i != bookDataObj.pages.length - 1) || (parent == 'ELE')) {
                var id = bookDataObj[bookDataObj.pages[i]].contentDocId;
                var pageObj = bookDataObj[bookDataObj.pages[i]];
                await this.getPageContent(id).then(function (res) {
                    if (res) {
                        var pageNumber = JSON.parse(pageContent.pageNumber);
                        pageNumber.value = pageObj.pageNumber;
                        //  pageContent.pageNumber = JSON.stringify(pageNumber);
                        res['pageContent'].pageNumber = JSON.stringify(pageNumber);;
                        self.createPageContentDoc(res);
                    }
                });

            }
        }

    }
    async resetPageNoToAllPages(bookDataObj, parent) {
        var self = this;
        let com = this.editorService.getIframeReference();
        for (let i = 0; i < bookDataObj.pages.length; i++) {
            if ((i != 0 && i != bookDataObj.pages.length - 1) || (parent == 'ELE')) {
                var id = bookDataObj[bookDataObj.pages[i]].contentDocId;
                var pageObj = bookDataObj[bookDataObj.pages[i]];
                await this.getPageContent(id).then(function (res) {
                    if (res) {
                        var pageNumber = JSON.parse(res['pageContent'].pageNumber);
                        pageNumber.visible = 'false';
                        pageNumber.position = '';
                        res['pageContent'].pageNumber = JSON.stringify(pageNumber);
                        self.createPageContentDoc(res);
                        com.setPageNumber(pageNumber); //reset PageNo for current page
                    }
                });

            }
        }
    }





    updateBookDataObj(bookDataObj) {
        var self = this;
        //
        this.pouchService.localDB.find({
            selector: { type: 'bookData', _id: bookDataObj._id },
        }).then(function (result) {
            if (result.docs.length > 0) {
                bookDataObj._rev = result.docs[0]._rev;
                result.docs[0] = bookDataObj;
                return self.pouchService.localDB.put(result.docs[0]).then(function (response) {
                    console.log(response);
                }).catch(function (err) {
                    console.log(err);
                });

            }
        }).catch(function (err) {

        });

    }
    createPageContentDoc(pageContent) {
        var self = this;
        self.pouchService.localDB.put(pageContent).then(function (result) {

        }).catch(function (err) {

        })
    }

    createBookPagesContentDocs(pageContents) {
        var self = this;
        self.pouchService.localDB.bulkDocs(pageContents, function (err, response) {
            if (err) {
                return console.log(err);
            } else {
                console.log("Documents created Successfully");
            }
        }).then(function (result) {
        }).catch(function (err) {
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/editOptions.service.ts